import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    addOrder: translate({ id: 'rm.sidebar.addorder' }),
    addOrderFromScratch: translate({ id: 'rm.sidebar.addorder.fromScratch' }),
    importOrders: translate({ id: 'rm.sidebar.addorder.importOrders' }),
  }))

  return api
}
